import { QueryClientProvider } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';

import { AuthProvider } from './auth/AuthProvider';
import { createQueryClient } from './queryClient';

interface AppProvidersProps {
  children: ReactNode;
}

/**
 * Single composition point for every cross-cutting provider. Features never
 * mount providers themselves — they consume them through hooks.
 */
export function AppProviders({ children }: AppProvidersProps) {
  const [queryClient] = useState(createQueryClient);

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>{children}</AuthProvider>
    </QueryClientProvider>
  );
}
